import gsap from 'gsap';

import BezierEasing from 'bezier-easing';

import Modal from './modal';
import StepsForm from './steps-form';

import { byId, qs, toggleClass } from '../base/dom-utils';

class ContactOverlay extends Modal {

    constructor(el, opts) {
        super(el, opts);

        this.$els.contactWrap = qs('.c-contact__wrap', this.$el);
        this.$els.contactTrigger = byId(this.options.contactTrigger);
        this.$els.modalClose = qs('.c-contact__close', this.$el);

        this.$els.pag = qs('.o-form__pag', this.$el);
        this.$els.progress = qs('.o-form__progress', this.$el);
        this.$els.counter = qs('.o-form__counter', this.$el);
        this.$els.wrap = qs('.o-form__wrap', this.$el);

        this.$els.formGroup = qs(this.options.formGroup, this.$el);

        // get collection of form elements
        this._steppedEls = [this.$els.pag, this.$els.progress, this.$els.counter, this.$els.wrap];

        this._scrollTop = 0;

    }


    beforeInit() {

        const modalEase = BezierEasing(0.61, 0.01, 0.08, 0.99);

        this.on('change:isContactOpen', (isOpen) => {

            this.setState('isModalOpen', isOpen);

            if (isOpen) {

                this.setRef('stepsForm', StepsForm, '#modal-form');

                // hide for first things
                gsap.set(this._steppedEls, {
                    opacity: 0
                });

                toggleClass(this.$els.formGroup, 'is-active', true);


                gsap.to(this.$els.contactTrigger, 0.6, {
                    scale: this.getScale(),
                    ease: new Ease(modalEase),
                    force3D: false,

                    onComplete: () => {
                        toggleClass(this.$el, 'is-open', true);
                        toggleClass(this.$els.contactTrigger, 'is-active', true);

                        setTimeout(() => toggleClass(this.$els.modalClose, 'is-entered', true), 500);
                    }
                });

            } else {

                if (this.$refs.stepsForm) {
                    this.$refs.stepsForm.destroy();
                    delete this.$refs.stepsForm;
                }

                gsap.to(this.$els.contactTrigger, 0.4, {
                    delay: 0.2,
                    scale: 1,
                    //ease: new Ease(modalEase),
                    force3D: false,
                    clearProps: 'scale',

                    onStart: () => {
                        toggleClass(this.$el, 'is-open', false);
                        toggleClass(this.$els.contactTrigger, 'is-active', false);
                        toggleClass(this.$els.modalClose, 'is-entered', false);
                    },

                    onComplete: () => {

                        gsap.set(this.$els.formGroup, {
                            autoAlpha: 1
                        });

                        gsap.set(this._steppedEls, {
                            opacity: 0
                        });

                    }
                });

            }

        });

        this.delegate('click', this.options.radio, () => {

            gsap.to(this.$els.formGroup, 0.35, {
                autoAlpha: 0,
                // zIndex: -1,
                onComplete: () => toggleClass(this.$els.formGroup, 'is-active', false)
            });

            gsap.to(this._steppedEls, 0.5, {
                delay: 0.3,
                opacity: 1
            });

        });
    }

    // bindKeys(e) {
    //
    //     const evt = e || window.event;
    //
    //     let isEscape = false;
    //
    //     if ('key' in evt) {
    //         isEscape = evt.key == "Escape";
    //     } else {
    //         isEscape = evt.keyCode == 27;
    //     }
    //
    //     if (isEscape) {
    //         this.set
    //     }
    // }
    //
    // unbindKey() {
    //
    // }

    getScale() {

        const trigRad = this.$els.contactTrigger.offsetWidth / 2;
        const trigBounds = this.$els.contactTrigger.getBoundingClientRect();
        const trigLeft = trigBounds.left + trigRad;
        const trigTop = trigBounds.top + trigRad;

        return Math.ceil(Math.sqrt( Math.pow(trigLeft, 2) + Math.pow(trigTop, 2) ) / trigRad);
    }

    getInitialState() {
        return Object.assign({
            isContactOpen: false
        }, super.getInitialState());
    }

    getDefaultOptions() {
        return {
            contactTrigger: 'contact-trigger',
            formGroup: '.o-form__group',
            radio: '.o-radio'
        };
    }
}

export default ContactOverlay;


/** WEBPACK FOOTER **
 ** ./components/contact-overlay.js
 **/